<template lang="pug">
.container
  el-form
    el-form-item(:label="$t('UUID / Name')")
      el-input.el-input(
        id="SearchByUUID-searchInput",
        v-model='params.uuid',
        type="text", name="uuid",
        ref="uuid",
        style="width: 90%;",
        :placeholder="$t('UUID / Name')",
        @input='handleInputChange()')
  table(width="100%", v-if='desktops.length > 0')
    tr.header-row
      th
        p {{ $t('UUID / Name / Network') }}
      th
        p {{ $t('Device') }}
      th
        p {{ $t('Last Modification') }}
      th
        p {{ $t('Action') }}
    tr.desktop-row(v-for='desktop in desktops', :key='desktop.id', :id="'SearchByUUID-desktop'+desktop.id")
      td
        .uuid-cell(@click="changeUUID(desktop)")
          span(v-html='highlight(desktop.uuid)')
          font-awesome-icon.icon(icon="edit")
        p(v-html='highlight(desktop.name)')
        p(v-html='highlight(desktop.Network.name)')
      td
        p(v-html='highlight(desktop.Device.name)')
        p(v-html='highlight(desktop.Device.description)')
      td
        p {{ humanTime(desktop.updatedAt) }}
      td
        .buttons
          el-button-group
            el-button(
              :id="'SearchByUUID-changeNetworkDesktop'+desktop.id",
              type='success',
              size='mini',
              :title="$t('Change network')",
              @click="changeNetwork(desktop)"
            )
              font-awesome-icon(icon="exchange-alt")
            el-button(
              :id="'SearchByUUID-deactivateDesktop'+desktop.id",
              type='success',
              size='mini',
              :title="$t('Deactivate device')",
              @click="actionSelected('deactivate', desktop)"
            )
              font-awesome-icon(icon="ban")
            el-button(
              :id="'SearchByUUID-resetSecretDesktop'+desktop.id",
              type='success',
              size='mini',
              :title="$t('Reset secret')",
              @click="actionSelected('resetSecret', desktop)"
            )
              font-awesome-icon(icon="unlock-alt")
            el-button(
              :id="'SearchByUUID-enterNetworkDesktop'+desktop.id",
              type='success',
              size='mini',
              :title="$t('Enter network')",
              @click="handleSelectNetwork(desktop.Network)"
            )
              font-awesome-icon(icon="sign-in-alt")
  el-dialog(:close-on-click-modal="false", title='', :visible.sync='networkSelectorVisible', @close='closeNetworkSelector()', append-to-body, width='40%')
    NetworkSelector(@networkSelected='networkSelected', :header='$t("Move device to Network")')
  el-dialog(:close-on-click-modal="false", title='', :visible.sync='UUIDSelectorVisible', @close='closeUUIDSelector()', append-to-body, width='40%')
    UUIDSelector(v-if='UUIDSelectorVisible', @UUIDChanged='UUIDChanged', :selectedDesktop='selectedDesktop', :header='$t("Change device UUID and update it\'s content and schedule - ") + selectedDesktop.Device.name + "/" + selectedDesktop.name')
  p.error(v-if='errors.length > 0 && !searchInProgress')
    span {{ $t('No desktops found...') }}
  ConfirmDialog(
    :confirmDialogVisible='confirmDialogVisible',
    :question='confirmDialogQuestion',
    :data='rightClickData',
    @confirmed='dialogConfirmed',
    @closed='dialogDenied'
  )
</template>

<script>
import Vue from 'vue'
import testUtils from './../Common/textUtils.mixin'
import NetworkSelector from './../Common/NetworkSelector'
import UUIDSelector from './../Common/UUIDSelector'
import ConfirmDialog from '../Common/ConfirmDialog'

export default {
  mixins: [testUtils],
  props: [],
  components: {
    NetworkSelector,
    UUIDSelector,
    ConfirmDialog
  },
  created () {
  },
  data () {
    return {
      errors: [],
      params: {
        uuid: undefined
      },
      selectedDevice: null,
      selectedDesktop: null,
      desktops: [],
      networkSelectorVisible: false,
      UUIDSelectorVisible: false,
      confirmDialogQuestion: null,
      confirmDialogVisible: false,
      rightClickData: {},
      searchInProgress: false,
      searchInputTimestamp: 0,
      debounceSearchTimeoutMS: 750, // according tu UX experts, it shall be 200-2000ms
      debounceSearchTimeoutPointer: undefined
    }
  },
  methods: {
    async actionSelected (action, desktop) {
      console.log(action, desktop)
      const localizedAction = this.$t(action)
      this.confirmDialogQuestion = `
        ${this.$t('Are you sure you want to perform ')}
        ${localizedAction}
        ${this.$t('on device UUID:')}
        ${desktop.uuid}?`
      this.rightClickData = {
        action,
        desktop
      }
      this.confirmDialogVisible = true
    },
    async dialogDenied (data) {
      this.confirmDialogVisible = false
      this.rightClickData = {}
      this.confirmDialogQuestion = null
    },
    async dialogConfirmed (payload) {
      await this[payload.action](payload.desktop)
      this.confirmDialogQuestion = null
      this.confirmDialogVisible = false
      this.rightClickData = {}
    },
    async networkSelected (network) {
      // console.log(network)
      this.errors = []
      await Vue.axios.post(
        '/device/changeNetwork',
        {
          networkId: network.id,
          deviceId: this.selectedDevice.id
        }
      ).then(response => {
        if (response.data.length === 0) return this.errors.push('not found')
        this.__search()
      }).catch(e => {
        this.errors = []
        this.errors.push(e)
      })
    },
    closeNetworkSelector () {
      this.networkSelectorVisible = false
    },
    closeUUIDSelector () {
      this.UUIDSelectorVisible = false
    },
    UUIDChanged () {
      this.closeUUIDSelector()
    },
    async changeNetwork (desktop) {
      this.networkSelectorVisible = true
      this.selectedDevice = desktop.Device
    },
    async changeUUID (desktop) {
      this.UUIDSelectorVisible = true
      this.selectedDesktop = desktop
    },
    async deactivate (desktop) {
      await Vue.axios.post(
        '/device/deactivate',
        {
          deviceId: desktop.Device.id
        }
      ).then(response => {
        if (response.data.length === 0) return this.errors.push('not found')
        this.__search()
      }).catch(e => {
        this.errors = []
        this.errors.push(e)
      })
    },
    async resetSecret (desktop) {
      await Vue.axios.post(
        '/deviceDesktop/resetSecret',
        {
          desktopId: desktop.id
        }
      ).then(response => {
        if (response.data.length === 0) return this.errors.push('not found')
        this.__search()
      }).catch(e => {
        this.errors = []
        this.errors.push(e)
      })
    },
    async handleInputChange () {
      if (this.params.uuid.length < 1) return false
      clearTimeout(this.debounceSearchTimeoutPointer)
      this.debounceSearchTimeoutPointer = setTimeout(async () => {
        await this.__search()
      }, this.debounceSearchTimeoutMS)
    },
    async __search () {
      this.searchInProgress = true
      this.errors = []
      await Vue.axios.post(
        '/device/searchByUUID',
        this.params
      ).then(response => {
        if (response.data.length === 0) {
          this.desktops = []
          return this.errors.push('not found')
        }
        this.desktops = response.data
      }).catch(e => {
        this.errors = []
        this.errors.push(e)
      })
      this.searchInProgress = false
    },
    // FIXME DRY
    async handleSelectNetwork (newNetwork) {
      this.$emit('changeNetwork', newNetwork.id)
    },
    highlight (string) {
      // Bug #5 found by Cypress tests fix. UUID may be null.
      if (!string) return

      if (this.params.uuid.length === 0) {
        return string
      }
      return string.replace('<', '&lt;').replace('>', '&gt;').replace(new RegExp(this.params.uuid.replace('<', '&lt;').replace('>', '&gt;'), 'gi'), match => {
        return '<span style="color:#056095">' + match + '</span>'
      })
    }
  },
  computed: {
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
.error {
  color: $--color-warning;
}
table {
  padding: 0px;
  border-spacing: 0px;
  th, td {
    text-align: left;
    width: 20%;
  }
  .desktop-row {
    td {
      border-bottom: $--border-light;
    }
    .uuid-cell {
      display: flex;
      align-items: center;
      cursor: pointer;
      // border: 1px solid red;
      // line-height: 1px;
      .icon {
        margin-left: 10px;
      }
    }
  }
}
// Somehow does not work with classes. Awfull.
span.markedSearchstring {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/Device/SearchByUUID.vue